import { useEffect, useState } from "react";
import { useNotificationContext } from "contexts/NotificationContext";
import { useParams } from "react-router-dom";
import { IUser } from "models/user";
import { fetchPassengerByIdApi } from "api/passenger";
import { useDataLoadingContext } from "contexts/DataLoadingContext";

export default function usePassengerDetail() {
  const id: string = useParams().id!;
  const { loadPassengers } = useDataLoadingContext();
  const { showError } = useNotificationContext();
  const [openBan, setOpenBan] = useState<boolean>(false);
  const [openActivate, setOpenActivate] = useState<boolean>(false);
  const [data, setData] = useState<{ loading: boolean; data?: IUser }>({
    loading: true,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [id, loadPassengers]);

  const fetchData = async () => {
    setData({ loading: true });
    const { data, error } = await fetchPassengerByIdApi(id);
    if (data?.data) {
      setData({ loading: false, data: data.data });
    } else showError(error!.message);
  };

  const handleOpenBan = () => setOpenBan(true);
  const handleCloseBan = () => setOpenBan(false);
  const handleOpenActivate = () => setOpenActivate(true);
  const handleCloseActivate = () => setOpenActivate(false);

  return {
    data,
    handleCloseActivate,
    handleCloseBan,
    handleOpenActivate,
    handleOpenBan,
    openActivate,
    openBan,
    fetchData,
  };
}
